define('app/models/organization_login',['app/setup'], function(takhfifan) {
  takhfifan.organizationLogin = Backbone.Model.extend({
    validation: {
      'login[username]': function (value, key, fields) {
        if (!value) {
          return i18n.t('contact_invalid')
        }
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value))
          && !(/^0{1}\d{10}$/.test(value))) {
          return i18n.t('contact_invalid');
        }
      },
      'login[password]': {
        required: true,
        rangeLength: [6,50],
        pattern: /^\S{6,50}$/,
        msg: i18n.t('password_invalid')
      }
   },
   defaults: {
    email: null,
    password: null
  }
});
});

